export const clsx = (...classNames: any[]) =>
  classNames.filter(Boolean).join(" ");

export const canUseDOM = (): boolean => {
  return !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  );
};

export const isBrowser = canUseDOM();

export function getPathUrl() {
  return window.parent.location.href.replace(/.*\/\/[^\/]*/, "");
}

export const isInViewport = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export function isElementFullyInViewport(elementId: string) {
  const element = document.getElementById(elementId);

  if (!element) {
    return false; // Element with the given ID does not exist
  }

  const rect = element.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
